<template>
    <vue-table-card title="Training Schedule" :show-search-box="false" :fields="fields"
                    :url="listUrl" :show-pagination="false" ref="table" :extra-params="{course: id}">
        <template #buttons>
            <btn color="success" icon="fa fa-plus" size="sm" @click="$refs.addModal.show()" text="Add"/>
        </template>

        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <btn size="xs" text="View" @click="setEdit(rowData)"/>
                <delete-btn @click="setDelete(rowData)"/>
            </div>
        </template>
        <template #is_enabled="{rowData}">
            <p v-if="rowData.is_enabled">Yes</p>
            <p v-else>No</p>
        </template>
        <template #image_file="{rowData}">
            <div class="container-image" @click="viewFile(rowData.image_file)">
                <img :src="rowData.image_file" alt="Avatar" class="c-image">
                <div class="c-overlay">
                    <div class="c-icon">
                        <i class="fa fa-eye"></i>
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <modal title="Add Training Schedule" ref="addModal" width="40r" header-color="primary" no-close-on-backdrop>
                <add-training-schedule @success="formSuccess" :course="id"/>
            </modal>

            <modal title="Edit Training Schedule" ref="editModal" width="40r" header-color="primary" no-close-on-backdrop>
                <edit-training-schedule :initial-data="editingItem" :course="id" @success="formSuccess"/>
            </modal>

            <delete-modal ref="deleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
                <p>You are about to delete the item <b v-html="deletingItem && deletingItem.name"></b>. Are you sure ?
                </p>

                <template #loading>
                    <loading-animation/>
                    Please wait while we delete <b v-html="deletingItem && deletingItem.name"></b>.
                </template>
            </delete-modal>
        </template>

    </vue-table-card>
</template>

<script>
import urls from '../../../../data/urls';
import AddTrainingSchedule from './AddTrainingSchedule';
import EditTrainingSchedule from './EditTrainingSchedule';

export default {
    name: 'TrainingSchedule',
    components: { EditTrainingSchedule, AddTrainingSchedule },
    data () {
        return {
            id: this.$route.params.id,
            listUrl: urls.admin.course.detailsUrl.trainingSchedule.list,
            addUrl: urls.admin.course.detailsUrl.trainingSchedule.addEdit,
            deleteUrl: urls.admin.course.detailsUrl.trainingSchedule.delete,
            editingItem: null,
            deletingItem: null,
            fields: [
                {
                    name: 'order',
                    sortField: 'order',
                    title: 'Order'
                },
                {
                    name: '__slot:image_file',
                    title: 'Image'
                },
                {
                    name: '__slot:is_enabled',
                    title: 'Enabled'
                },
                {
                    name: '__slot:actions',
                    titleClass: 'center aligned text-right',
                    dataClass: 'aligned text-right'
                }
            ]
        };
    },
    methods: {
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            const refs = this.$refs;
            refs.addModal.close();
            refs.editModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.$refs.editModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.deleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$refs.deleteModal.close();
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.table.refreshTable();
        }
    }
};
</script>
